import { MantineProvider } from '@mantine/core';
import { Suspense } from 'react';
import LoadingScreen from './components/LoadingScreen';
import CustomFonts from './fonts/CustomFonts';
import AppRoutes from './routes/AppRoutes';
import baseTheme from './theme/base';

const App = () => {
    return (
        <MantineProvider withGlobalStyles withNormalizeCSS theme={baseTheme}>
            <CustomFonts />
            <Suspense fallback={<LoadingScreen />}>
                <AppRoutes />
            </Suspense>
        </MantineProvider>
    );
};

export default App;
